export const appName = 'ACT4';